






















































































































































































import BaseComponent from '@/components/base-component.vue';
import BagModelPrescription from '@/components/prescription/bag-model-prescription.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PdfDisplayDialog from '@/components/UI/pdf-display-dialog.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import {
  isDenied
} from '@/helpers/validatePrescriptionStatus';
import * as service from '@/services/prescription';
import { getLocalUser } from '@/services/session-data';
import * as prescriptionStatus from '@/settings/consts/prescription-status';
import * as resize from "@/subjects/resize";
import moment from 'moment';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BagModelDetailsPrescButton from './bag-model-details-presc-btn.vue';
import HistoryDetailsPrescButton from './history-details-presc-btn.vue';
import ProductsPrescriptionList from './products-list.vue';


@Component({
  components: { 
    PermissionAuth, 
    ListMessages, 
    BagModelPrescription, 
    HistoryDetailsPrescButton, 
    BagModelDetailsPrescButton, 
    ProductsPrescriptionList,
    PdfDisplayDialog 
  },
})
export default class PrescriptionListTable extends BaseComponent {   
  @Prop()
  public data!: any[];
  @Prop(Boolean)
  public hideCopy?: boolean;
  @Prop(Boolean)
  public hideProducts?: boolean;
  @Prop(Boolean)
  public hideStatus?: boolean;
  @Prop(Boolean)
  public hideClient?: boolean;
  @Prop({
    default: false,
  })
  public error: boolean;
  @Prop({
    default: false,
  })
  public loading: boolean;
  @Prop({
    default: 0,
  })
  public totalItems?: number;

  showPdfDialogFlag = false;
  urlPdf = null;
  titlePdf = null;
  filenamePdf = null;

  public pagination: any = {
    sortBy: 'dataPrescricao',
    totalItems: 0,
  };

  @Watch('totalItems')
  private totalItensChange() {
    this.pagination.totalItems = this.totalItems;
  }
  

  public headers: any[] = [];
  public currentUserId: string = null;

  

  private idGraficoBolsa = null;

  smallScreen: boolean = resize.isXsOrSmSizeScreen();
  xsScreen: boolean = resize.isXsSizeScreen();

  get prescriptionStatus(): any {
    return prescriptionStatus;
  }

  @Watch('pagination')
  public onChangePagination(): void {
    this.$emit('changePagination', this.pagination);
  }

  @Watch('data')
  public onChangeData(): void {    
    this.setHeaders();
  }

  public currentUser: any = {};

  public beforeMount(): void {
    getLocalUser().subscribe((currentUser) => {      
      this.currentUserId = currentUser? currentUser.idLogin : null;
      this.currentUser = currentUser;
    });
    this.setHeaders();
    this.pagination.rowsPerPage = 25; //resize.isXsSizeScreen() ? 10 : 25;

    resize.windowSizeChanged$.subscribe((val) => {
      this.xsScreen = resize.isXsSizeScreen();
      this.smallScreen = resize.isXsOrSmSizeScreen();
    });
  }

  private exibirQuantidade() {
    return this.data && this.data.filter(p => p.quantidade > 1).length > 0
  }

  public hasReport(status: string): boolean {
    // return isSentToProduction(status) || isDenied(status)
    return true;
  }

  public getStatus(status: string): any {
    return prescriptionStatus.STATUS_PRESCRIPTION_LIST.filter(s => s.key == status)[0];
  }

  public isDenied(status): boolean {
    return isDenied(status);
  }

  public onEditItem(item: any, isVisualize: boolean = false): void {
    this.loader.start('Carregando item...');
    service.getPrescription(item.idPrescricao).subscribe(
      (data) => {
        this.$emit(!!isVisualize ? 'visualize' : 'edit', data);
        this.loader.stop();
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar o item', 'error');
      },
    );
  }

  public downloadPDF(item: any): void {
    this.loader.start('Gerando relatório...');
    service.downloadPDF(item.idPrescricao).subscribe(
      (url) => {
        if (!url) {
          this.toast.show('Ocorreu um erro ao carregar o relatório', 'error');
        }
        
        if (this.smallScreen || this.xsScreen) {
          this.showPdfDialog(url, `${item.dataEntregaFmt} - ${item.paciente.nome}`, `prescricao_${item.idSiPro}_${moment(new Date()).format('YYYYMMDDHHmmss')}.pdf`);
        } else {
          window.open(url, '_blank');
        }
        this.loader.stop();
      },
      () => {
        this.toast.show('Ocorreu um erro ao carregar o relatório', 'error');
        this.loader.stop();
      },
    );
  }
  
  showPdfDialog(url, title, filename) {
    this.showPdfDialogFlag = true;
    this.urlPdf = url;
    this.titlePdf = title;
    this.filenamePdf = filename;
  }

  onClosePdfDialog() {
    this.showPdfDialogFlag = false;
  }

  private setHeaders(): void {
    this.headers = [];
    this.headers.push({ text: 'ID', value: 'idSiPro', class: 'px-2' });
    if (this.exibirQuantidade()) {
      this.headers.push({ text: 'Quantidade', value: 'quantidade', class: 'px-2', align: 'center' });
    }
    if(this.isEmede()){
      this.headers.push({
        text: 'Produção em',
        value: 'dataProducao',
        class: 'px-2',
      });
    }
    this.headers.push({
      text: 'Entrega em',
      value: 'dataPrescricao',
      class: 'px-2',
    });
    this.headers.push({
      text: 'Criado em',
      value: 'dataCriacao',      
    });

    if (!this.hideClient) {
      this.headers.push({
        text: 'Unidade',
        value: 'unidade.nome',
        class: 'px-2',
      });
    }

    this.headers.push({
      text: 'Médico',
      value: 'medico.nome',
      class: 'px-2',
    });
    this.headers.push({
      text: 'Paciente',
      value: 'paciente.nome',
      class: 'px-2',
    });

    if (!this.hideStatus) {
      this.headers.push({
        text: 'Status',
        value: 'statusPrescricao',
        align: 'center',
        class: 'px-2',
      });
    }

    if (!this.hideProducts) {
      this.headers.push({
        text: 'Produtos',
        value: 'produtos',
        align: 'left',
        sortable: false,
        class: 'px-2',
      });
    }

    this.headers.push({
      text: 'Ações',
      value: 'actions',
      align: 'center',
      sortable: false,
      class: 'px-2',
    });
  }

}
